import { first } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { JEService } from 'src/app/services/je-services.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-basic',
  templateUrl: './basic.component.html',
  styleUrls: ['./basic.component.scss']
})
export class BasicComponent implements OnInit {

  basicDetailsForm: FormGroup;
  isSubmitted = false;
  autoId: any;
  physicalVerficationApplicationData: any;
  public autoResize: boolean = true;
  longPosition: any;
  latPosition: any;
  editBilledData: boolean = false;
  preEstimationGeolocationsArray: any = []
  jegeolocationsarray: any = []
  xengeolocationsarray: any = []
  mapEnable = false;
  coordinateError: any
  preEstimationMapoverlays: any = [];
  jeMapoverlays: any = [];
  jeMapoptions: any;
  xenMapoverlays: any = [];
  xenMapoptions: any;
  preEstimateMapoptions: any;
  preEstimateCoordinates: any = [];
  coordinatesVerified = false
  jeLogin = false
  xenLogin = false
  jeorxenLogin = false
  dimicadaLogin = false
  ddAssociateLogin = false
  selectedSurveyType : any;
  preEstimationDate: any;

  constructor(private _fb: FormBuilder, private route: ActivatedRoute, private router: Router, private cryptoJsService: CryptoJsService, private jeService: JEService, private messageService: MessageService,private loader: AppLoaderService) {
    const tokenData = sessionStorage.getItem('token') ? JSON.parse(sessionStorage.getItem('token')) : {}
    console.log('token.role', tokenData?.role)
    if(tokenData && (tokenData.role == 'JE' || tokenData.role == 'CJE')){ 
      this.jeLogin = true
      this.jeorxenLogin = true
      sessionStorage.setItem('jecoordinatesVerified', JSON.stringify(false));
      sessionStorage.setItem('myPhysicalSurveyType', JSON.stringify(1));
    }
    if(tokenData && (tokenData.role == 'XEN' || tokenData.role == 'CXEN')){ 
     this.xenLogin = true
     this.jeorxenLogin = true
     sessionStorage.setItem('myPhysicalSurveyType', JSON.stringify(0));
     sessionStorage.setItem('xencoordinatesVerified', JSON.stringify(false));
    }
    if(tokenData && tokenData.role == 'DMICADA'){
      this.dimicadaLogin = true
    }
    if(tokenData && tokenData.role == 'DD Associate'){
      this.ddAssociateLogin = true
    }
    
   }

  ngOnInit(): void {
    if(sessionStorage.getItem('miPhysicalApplicationData')){
      sessionStorage.removeItem('miPhysicalApplicationData');
    }
    if(environment.production == false){
      console.log("local/staging");
    }
    else if(environment.production == true){
      console.log("Production");
    }
    sessionStorage.removeItem('miPhysicalAppJEGPSCoordinates');
    this.jegeolocationsarray = [];
    this.selectedSurveyType = 0
    this.jeMapoptions = {
      center: { lat: 29.0588, lng: 76.0856 },
      zoom: 17,
      mapTypeId: google.maps.MapTypeId.SATELLITE
    };
    this.xenMapoptions = {
      center: { lat: 29.0588, lng: 76.0856 },
      zoom: 17,
      mapTypeId: google.maps.MapTypeId.SATELLITE
    };
    this.preEstimateMapoptions = {
      center: { lat: 29.0588, lng: 76.0856 },
      zoom: 17,
      mapTypeId: google.maps.MapTypeId.SATELLITE
    };
    if (sessionStorage.getItem(this.cryptoJsService.Encrypt('editBilledData'))) {
      this.editBilledData = Boolean(this.cryptoJsService.DecryptData(sessionStorage.getItem(this.cryptoJsService.Encrypt('editBilledData'))));
    }

    this.getGPSCoordinates();
    console.log("Inside On Init");
    console.log('getPosition', this._getPosition())
    this.basicDetailsForm = this._fb.group({
      farmersName: ['', Validators.required],
      MIArea: ['', Validators.required],
    });
    this.route.queryParams
      .subscribe(params => {
        this.autoId = this.cryptoJsService.DecryptData(params.autoId);
        if (this.autoId) {
          // if ((JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.AutoId) == this.autoId) {
          //   console.log('Inside True', (JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.AutoId) == this.autoId);
          //   this.physicalVerficationApplicationData = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'));
          //   this.setupGeoLocations(this.physicalVerficationApplicationData)
          //   console.log(this.physicalVerficationApplicationData, 'basicdetails', this.preEstimateCoordinates)
          // } else {
            // console.log('Inside False', (JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.AutoId) == this.autoId);
            this.loader.start();
            let sessionToken = sessionStorage.getItem('token');
            let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
            this.jeService.getApplicationDataForPhysicalVerification(this.autoId, JSON.parse(payload)?.sub).pipe(first())
              .subscribe({
                next: (data: any) => {
                  this.loader.close();
                  let Obj = {}
                  if(sessionStorage.getItem('myPhysicalSurveyType') && JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.AutoId == this.autoId){
                    this.selectedSurveyType = sessionStorage.getItem('myPhysicalSurveyType')
                  } else if(data.SurveyType) {
                    this.selectedSurveyType= data.SurveyType
                    sessionStorage.setItem('myPhysicalSurveyType', JSON.stringify(this.selectedSurveyType));
                  }
                  this.physicalVerficationApplicationData = data;
                  // this.landArea = data?.MIArea;
                  if(sessionStorage.getItem('PVModifiedLandArea') && JSON.parse(sessionStorage.getItem('PVModifiedLandArea'))?.autoId == this.autoId){
                    let val = JSON.parse(sessionStorage.getItem('PVModifiedLandArea'))?.MIArea;
                    this.basicDetailsForm.controls.MIArea.setValue(val);
                  }else{
                    this.basicDetailsForm.controls.MIArea.setValue(data?.MIArea);
                  }
                  sessionStorage.setItem('miPhysicalApplicationData', JSON.stringify(data));
                  Obj['listGPSCoordinatesPreEst'] = data.listGPSCoordinatesPreEst
                  if(sessionStorage.getItem('miPhysicalAppJEGPSCoordinates') &&
                   JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.AutoId == this.autoId
                  && JSON.parse(sessionStorage.getItem('miPhysicalAppJEGPSCoordinates'))){
                    Obj['listGPSCoordinatesJE'] = JSON.parse(sessionStorage.getItem('miPhysicalAppJEGPSCoordinates'))
                  }else {
                    Obj['listGPSCoordinatesJE'] = data.listGPSCoordinatesJE
                  }
                  if(sessionStorage.getItem('miPhysicalAppXENGPSCoordinates') 
                  && JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.AutoId == this.autoId &&
                  JSON.parse(sessionStorage.getItem('miPhysicalAppXENGPSCoordinates'))){
                    Obj['listGPSCoordinatesXEN'] = JSON.parse(sessionStorage.getItem('miPhysicalAppXENGPSCoordinates'))
                  } else{
                    Obj['listGPSCoordinatesXEN'] = data.listGPSCoordinatesXEN
                  }
                    this.setupGeoLocations(Obj)
                    this.preEstimationDate = new Date(data?.PreEstDate ? data?.PreEstDate : "01-01-01")
                    console.log (this.preEstimationDate)
                },
                error: () => {
                  this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Physical Applications not loaded.' });
                }
              });
          // }
        } else {
          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be empty' });
          return;
        }

      }
      );

  }

  get basicDetailsFormControls() {
    return this.basicDetailsForm.controls;
  }

  getGPSCoordinates() {
    this._getPosition().then((pos) => {
      this.latPosition = pos.lat;
      this.longPosition = pos.lng;
      console.log(this.latPosition, this.longPosition);
    });
  }

  _getPosition(): Promise<any> {
    this.loader.start();
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          this.loader.close();
          resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
        },
        (err) => {
          this.loader.close();
          reject(err);
        }
      );
    });
  }

  onBasicDetailsFormSubmit() {
    this.isSubmitted = true;
    console.log("this.xengeolocationsarray", this.xengeolocationsarray, this.jegeolocationsarray, this.selectedSurveyType)
    if (this.jeLogin && this.jegeolocationsarray.length < 4) {
      this.coordinateError = 'PLEASE_PROVIDE_ATLEAST_4_GPS_COORDINATES'
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please provide atleast 4 GPS Coordinates' });
      return;
    } else if (this.xenLogin && this.xengeolocationsarray.length < 4 && this.selectedSurveyType == 1) {
      console.log("this.xengeolocationsarray", this.xengeolocationsarray)
      this.coordinateError = 'PLEASE_PROVIDE_ATLEAST_4_GPS_COORDINATES1'
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please provide atleast 4 GPS Coordinates' });
      return;
    } else if(this.preEstimateCoordinates&& this.preEstimateCoordinates.length > 0 && !this.verifyCoordinates(this.preEstimateCoordinates, this.jegeolocationsarray, false) && this.jeLogin && this.preEstimationDate > new Date("03-22-23")){
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Captured GPS Coordinates are Not Matching' });
    }  else if(this.preEstimateCoordinates&& this.preEstimateCoordinates.length > 0 && !this.verifyCoordinates(this.preEstimateCoordinates, this.xengeolocationsarray, true) && this.xenLogin && this.selectedSurveyType == 1 && this.preEstimationDate > new Date("03-22-23")){
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Captured GPS Coordinates are Not Matching' });
    }else {
      if (this.xenLogin) {
        sessionStorage.setItem('xencoordinatesVerified', JSON.stringify(true));
      } else {
        sessionStorage.setItem('jecoordinatesVerified', JSON.stringify(true));
      } 
      //  let jegeoCoordinates = []
      // let xengeoCoordinates = []

      // for (let index = 0; index < this.jegeolocationsarray.length; index++) {
      //   const gpsObj = {
      //     "cornerID": index + 1,
      //     "latitude": this.jegeolocationsarray[index].lat,
      //     "longitude": this.jegeolocationsarray[index].lng
      //   }
      //   jegeoCoordinates.push(gpsObj);
      // }
      // for (let index = 0; index < this.xengeolocationsarray.length; index++) {
      //   const xengpsObj = {
      //     "cornerID": index + 1,
      //     "latitude": this.xengeolocationsarray[index].lat,
      //     "longitude": this.xengeolocationsarray[index].lng
      //   }
      //   xengeoCoordinates.push(xengpsObj);
      // }
      if(sessionStorage.getItem('userRole')=='DD Associate'){
        this.route.queryParams
      .subscribe(params => {
        if (params.autoId) {
          sessionStorage.setItem('miPhysicalAppJEGPSCoordinates', JSON.stringify(this.jegeolocationsarray));
          sessionStorage.setItem('miPhysicalAppXENGPSCoordinates', JSON.stringify(this.xengeolocationsarray));
          this.router.navigate([this.router.url.split('/')[1], 'application', 'image-attachment'], { queryParams: { autoId: params.autoId, appId: params.appId } });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
        }
      }
      );
      }
      else{
    this.route.queryParams
      .subscribe(params => {
        if (params.autoId) {
          sessionStorage.setItem('miPhysicalAppJEGPSCoordinates', JSON.stringify(this.jegeolocationsarray));
          sessionStorage.setItem('miPhysicalAppXENGPSCoordinates', JSON.stringify(this.xengeolocationsarray));
          this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
        }
      }
      );
    }
  }
  }
  addOverlay() {
    this.jeMapoverlays.push(new google.maps.Polygon({
      paths: this.jegeolocationsarray,
      strokeOpacity: 0.5, strokeWeight: 1, fillColor: '#1976D2', fillOpacity: 0.35
    }))
  }
  addMarkers(row: any, index) {
    this.jeMapoverlays.push(new google.maps.Marker({ position: { lat: row?.lat, lng: row?.lng }, title: 'Coordinate ' + row?.CornerID}))
  }
  xenAddOverlay() {
    this.xenMapoverlays.push(new google.maps.Polygon({
      paths: this.xengeolocationsarray,
      strokeOpacity: 0.5, strokeWeight: 1, fillColor: '#1976D2', fillOpacity: 0.35
    }))
  }
  xenAddMarkers(row: any, index) {
    this.xenMapoverlays.push(new google.maps.Marker({ position: { lat: row?.lat, lng: row?.lng }, title: 'Coordinate ' + row?.CornerID}))
  }
  preEstimationAddOverlay() {
    this.preEstimationMapoverlays.push(new google.maps.Polygon({
      paths: this.preEstimationGeolocationsArray,
      strokeOpacity: 0.5, strokeWeight: 1, fillColor: '#1976D2', fillOpacity: 0.35
    }))
  }
  preEstimationAddMarkers(row: any, index) {
    console.log("preEstimationMapoverlays", this.preEstimationMapoverlays,)
    this.preEstimationMapoverlays.push(new google.maps.Marker({ position: { lat: row?.lat, lng: row?.lng }, title: 'Coordinate ' + row?.CornerID}))
  }
  onCapture(xenlogin) {
    let instant = this
    this.coordinateError = ''
    if ('geolocation' in navigator) {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };
      function success(pos) {
        let isExist = false
        if(xenlogin) {
           isExist =  instant.xengeolocationsarray.find(data=>{ if(data.latitude == pos.coords.latitude && data.longitude == pos.coords.longitude)
          {
            return data
          }})
        } else {
          isExist =  instant.jegeolocationsarray.find(data=>{ if(data.latitude == pos.coords.latitude && data.longitude == pos.coords.longitude)
            {
              return data
            }})
        }
        if(isExist) {
          instant.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please move to a different location to get new coordinates.' });
        } else{
        const obj = {
          CornerID: xenlogin ? instant.xengeolocationsarray.length + 1 : instant.jegeolocationsarray.length + 1,
          cornerID: xenlogin ? instant.xengeolocationsarray.length + 1 : instant.jegeolocationsarray.length + 1,
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude
        }
        xenlogin ? instant.xengeolocationsarray.push(obj) : instant.jegeolocationsarray.push(obj)
        instant.onSave(xenlogin)
      }
      }

      function error(err) {
        console.log(`ERROR(${err.code}): ${err.message}`);
      }
      navigator.geolocation.getCurrentPosition(success, error, options);
    }

  }
  onDelect(i, xenlogin) {
    if(xenlogin) {
    this.xengeolocationsarray.splice(i, 1);
    for (let index = 0; index < this.xengeolocationsarray.length; index++) {
      this.xengeolocationsarray[index].CornerID = index + 1;
      this.xengeolocationsarray[index].cornerID = index + 1;
    }
    if (this.xengeolocationsarray.length == 0) {
      this.mapEnable = false;
    } else {
      this.xenMapoptions.center = this.xengeolocationsarray[0]
      this.mapEnable = false;
      this.mapEnable = true;
      this.xenMapoverlays = []
      this.xengeolocationsarray.forEach((row, index) => {
        this.xenAddMarkers(row, index)
      });
      this.xenAddOverlay()
    }
  }else {
    this.jegeolocationsarray.splice(i, 1);
    for (let index = 0; index < this.jegeolocationsarray.length; index++) {
      this.jegeolocationsarray[index].CornerID = index + 1;
      this.jegeolocationsarray[index].cornerID = index + 1;
    }
    if (this.jegeolocationsarray.length == 0) {
      this.mapEnable = false;
    } else {
      this.jeMapoptions.center = this.jegeolocationsarray[0]
      this.mapEnable = false;
      this.mapEnable = true;
      this.jeMapoverlays = []
      this.jegeolocationsarray.forEach((row, index) => {
        this.addMarkers(row, index)
      });
      this.addOverlay()
    }
  }
  sessionStorage.setItem('miPhysicalAppJEGPSCoordinates', JSON.stringify(this.jegeolocationsarray));
  sessionStorage.setItem('miPhysicalAppXENGPSCoordinates', JSON.stringify(this.xengeolocationsarray));
  }
  onSave(xenlogin) {
    this.mapEnable = false;
    this.mapEnable = true;
    if(xenlogin){
      this.xenMapoptions.center = this.xengeolocationsarray[0]
      this.xenMapoverlays = []
      this.xengeolocationsarray.forEach((row, index) => {
        this.xenAddMarkers(row, index)
      });
      this.xenAddOverlay()
    } else {
      this.jeMapoptions.center = this.jegeolocationsarray[0]
      this.jeMapoverlays = []
      this.jegeolocationsarray.forEach((row, index) => {
        this.addMarkers(row, index)
      });
      this.addOverlay()
    }
    sessionStorage.setItem('miPhysicalAppJEGPSCoordinates', JSON.stringify(this.jegeolocationsarray));
    sessionStorage.setItem('miPhysicalAppXENGPSCoordinates', JSON.stringify(this.xengeolocationsarray));
    if(this.xenLogin && this.xengeolocationsarray && this.xengeolocationsarray > 3) {
      this.verifyCoordinates(this.preEstimateCoordinates, this.xengeolocationsarray, true)
    } else if(this.jeLogin && this.jegeolocationsarray && this.jegeolocationsarray > 3){
      console.log(this.preEstimateCoordinates, this.jegeolocationsarray, '&&&&&&')
      this.verifyCoordinates(this.preEstimateCoordinates, this.jegeolocationsarray, false)
    
    }
  }

  verifyCoordinates(coordinates1, coordinates2, xenlogin) {
    let element1coordinatelat = 0
    let element1coordinatelng = 0
    let element2coordinatelat = 0
    let element2coordinatelng = 0
    for (let index = 0; index < coordinates1.length; index++) {
      element1coordinatelat = element1coordinatelat + coordinates1[index].latitude;
      element1coordinatelng = element1coordinatelng + coordinates1[index].longitude;
    }
    for (let index = 0; index < coordinates2.length; index++) {
      element2coordinatelat = element2coordinatelat + coordinates2[index].latitude;
      element2coordinatelng = element2coordinatelng + coordinates2[index].longitude;
    }
    const x1latitude = element1coordinatelat / coordinates1.length
    const y1logitude = element1coordinatelng / coordinates1.length
    const x2latitude = element2coordinatelat / coordinates2.length
    const y2logitude = element2coordinatelng / coordinates2.length
    let distance = this.distance(x1latitude, y1logitude, x2latitude, y2logitude)
    console.log(distance, 'distance')
    if(!this.preEstimateCoordinates  || (this.preEstimateCoordinates&& this.preEstimateCoordinates.length==0)) {
      sessionStorage.setItem('xencoordinatesVerified', JSON.stringify(true));
      sessionStorage.setItem('jecoordinatesVerified', JSON.stringify(true));
      return true
    } else  if (distance < 500) {
      if (xenlogin) {
        sessionStorage.setItem('xencoordinatesVerified', JSON.stringify(true));
      } else {
        sessionStorage.setItem('jecoordinatesVerified', JSON.stringify(true));
      }
      return true
    }else{
      if (xenlogin) {
        sessionStorage.setItem('xencoordinatesVerified', JSON.stringify(false));
      } else {
        sessionStorage.setItem('jecoordinatesVerified', JSON.stringify(false));
      } return false
    }
  }


  distance(lat1, lon1, lat2, lon2) {
    const R = 6371e3; // metres
    const radlat1 = lat1 * Math.PI / 180; // radlat1, radlat2 in radians
    const radlat2 = lat2 * Math.PI / 180;
    const radlon1 = (lat2 - lat1) * Math.PI / 180;
    const radlon2 = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(radlon1 / 2) * Math.sin(radlon1 / 2) +
      Math.cos(radlat1) * Math.cos(radlat2) *
      Math.sin(radlon2 / 2) * Math.sin(radlon2 / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const d = R * c; // in metres
    return d
  }
  setupGeoLocations(data){
    console.log(data, 'data')
    this.jeMapoverlays = []
    this.xenMapoverlays = []
    this.preEstimateCoordinates = data.listGPSCoordinatesPreEst;
    this.preEstimationGeolocationsArray = data?.listGPSCoordinatesPreEst;
    

    this.preEstimateCoordinates.forEach((data, index)=>{
      data.latitude = data.Latitude
      data.longitude = data.Longitude
      data.lat = data.Latitude
      data.lng = data.Longitude
    })
    if (data.listGPSCoordinatesJE && data.listGPSCoordinatesJE.length > 0) {
      for (let index = 0; index < data.listGPSCoordinatesJE.length; index++) {
        data.listGPSCoordinatesJE[index].latitude = data.listGPSCoordinatesJE[index].Latitude ? data.listGPSCoordinatesJE[index].Latitude : data.listGPSCoordinatesJE[index].latitude
        data.listGPSCoordinatesJE[index].longitude = data.listGPSCoordinatesJE[index].Longitude ? data.listGPSCoordinatesJE[index].Longitude : data.listGPSCoordinatesJE[index].longitude
        data.listGPSCoordinatesJE[index].lat = data.listGPSCoordinatesJE[index].latitude
        data.listGPSCoordinatesJE[index].lng = data.listGPSCoordinatesJE[index].longitude
        data.listGPSCoordinatesJE[index].cornerID = data.listGPSCoordinatesJE[index].CornerID ? data.listGPSCoordinatesJE[index].CornerID : data.listGPSCoordinatesJE[index].cornerID
      }
      this.jegeolocationsarray = data.listGPSCoordinatesJE
      sessionStorage.setItem('miPhysicalAppJEGPSCoordinates', JSON.stringify(this.jegeolocationsarray));
      this.verifyCoordinates(this.preEstimateCoordinates, this.jegeolocationsarray, false)
    }
      if (data.listGPSCoordinatesXEN && data.listGPSCoordinatesXEN.length > 0) {
        for (let index = 0; index < data.listGPSCoordinatesXEN.length; index++) {
          data.listGPSCoordinatesXEN[index].latitude = data.listGPSCoordinatesXEN[index].Latitude? data.listGPSCoordinatesXEN[index].Latitude : data.listGPSCoordinatesXEN[index].latitude
          data.listGPSCoordinatesXEN[index].longitude = data.listGPSCoordinatesXEN[index].Longitude? data.listGPSCoordinatesXEN[index].Longitude : data.listGPSCoordinatesXEN[index].longitude
          data.listGPSCoordinatesXEN[index].lat = data.listGPSCoordinatesXEN[index].latitude
          data.listGPSCoordinatesXEN[index].lng = data.listGPSCoordinatesXEN[index].longitude
          data.listGPSCoordinatesXEN[index].cornerID = data.listGPSCoordinatesXEN[index].CornerID? data.listGPSCoordinatesXEN[index].CornerID : data.listGPSCoordinatesXEN[index].cornerID
        }
      this.xengeolocationsarray = data.listGPSCoordinatesXEN
      sessionStorage.setItem('miPhysicalAppXENGPSCoordinates', JSON.stringify(this.xengeolocationsarray));
      this.verifyCoordinates(this.preEstimateCoordinates, this.xengeolocationsarray, true)
    }

    if(this.preEstimationGeolocationsArray && this.preEstimationGeolocationsArray.length > 0) {
      this.preEstimateMapoptions.center = this.preEstimationGeolocationsArray[0]
      this.mapEnable = true;
      this.preEstimationGeolocationsArray.forEach((row, index) => {
        this.preEstimationAddMarkers(row, index)
      });
      this.preEstimationAddOverlay()
    }

    if(this.xengeolocationsarray && this.xengeolocationsarray.length > 0) {
      this.xenMapoptions.center = this.xengeolocationsarray[0]
      this.mapEnable = true;
      this.xengeolocationsarray.forEach((row, index) => {
        this.xenAddMarkers(row, index)
      });
      this.xenAddOverlay()
    }

    if(this.jegeolocationsarray && this.jegeolocationsarray.length > 0) {
      this.jeMapoptions.center = this.jegeolocationsarray[0]
      this.mapEnable = true;
      this.jegeolocationsarray.forEach((row, index) => {
        this.addMarkers(row, index)
      });
      this.addOverlay()
    }
  }
  getSurveyType(event){
    this.selectedSurveyType = event
    sessionStorage.setItem('myPhysicalSurveyType', JSON.stringify(event));
  }

  ngOnDestroy() {
    // sessionStorage.removeItem('miPhysicalAppJEGPSCoordinates');
    // sessionStorage.setItem('miPhysicalApplicationData', JSON.stringify(data));
    if(this.physicalVerficationApplicationData.MIArea != this.basicDetailsForm.controls.MIArea.value){
      // if(localStorage.getItem('PVModifiedLandArea')){
        
      // }
      console.log('inside ngOndestroy true')
      sessionStorage.setItem('PVModifiedLandArea', JSON.stringify({ autoId: this.autoId, MIArea: this.basicDetailsForm.controls.MIArea.value}));
      let miPhysicalApplicationData = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'));
      miPhysicalApplicationData.MIArea = this.basicDetailsForm.controls.MIArea.value;
      sessionStorage.setItem('miPhysicalApplicationData', JSON.stringify(miPhysicalApplicationData));
    }
  }

}
